import { httpPost } from '../utils/http';

export const apiChangeOrganization = (orgUrl: string): Promise<string> =>
  httpPost('/MainMenu/ChangeOrganizationForUser', { model: { OrganizationPermanentUrl: orgUrl } });
